import React from 'react';

import { STFlex } from 'design/atoms/Container';
import { BaseText } from 'design/atoms/Text';
import { STIcon } from 'design/atoms/Icon';
import Accordion from 'src/components/Accordion';
import { analytics } from 'src/utils/firebase';

const { AccordionBody, AccordionHeader, AccordionItem } = Accordion;

export const FaqsAccordion = ({ data }) => {
  return (
    <STFlex width={['80%', '50%']}>
      <Accordion>
        {data.map((faq, index) => (
          <AccordionItem key={index} mt="10px">
            {({ isActive, toggle }) => (
              <>
                <AccordionHeader
                  onClick={() => {
                    if (!isActive) {
                      analytics.logEvent('faq_view', {
                        question: faq.question,
                      });
                    }
                    toggle();
                  }}
                  bg={isActive ? '#006FAE' : '#F9FCFF'}
                >
                  <STFlex
                    px={3}
                    py={2}
                    justifyContent="space-between"
                    alignItems="center"
                    h={[60, 50]}
                  >
                    <BaseText
                      variant="whiteRegular"
                      fontSize={16}
                      fontFamily="montserrat"
                      fontWeight={600}
                      color={isActive ? 'white' : '#202833'}
                    >
                      {faq.question}
                    </BaseText>
                    {isActive ? (
                      <STIcon onClick={toggle} icon="ChevronUp" color="white" />
                    ) : (
                      <STIcon
                        onClick={() => {
                          toggle();
                        }}
                        icon="ChevronDown"
                        color="primary"
                      />
                    )}
                  </STFlex>
                </AccordionHeader>
                {isActive && (
                  <AccordionBody bg="white">
                    <STFlex px={3} py={1} flexDirection="column" mb={1}>
                      <BaseText
                        fontSize={17}
                        key={index}
                        fontFamily="montserrat"
                        color="#5A5A5A"
                        fontWeight={400}
                      >
                        <span
                          dangerouslySetInnerHTML={{ __html: faq.answer }}
                        />
                      </BaseText>
                    </STFlex>
                  </AccordionBody>
                )}
              </>
            )}
          </AccordionItem>
        ))}
      </Accordion>{' '}
    </STFlex>
  );
};
